<main class="painted-shell single-panel">
	<section class="panel">
		<button class="back-link" type="button" (click)="returnToApp()">
			My Apps
		</button>
		<h1>More App Launcher capacity is coming soon.</h1>
		<p class="hero-lede">
			Tell us what you need next, and the App Launcher team will follow up
			as expanded access becomes available.
		</p>

		<div
			*ngIf="state.interestSubmitted; else interestFormTpl"
			class="confirmation"
		>
			<span class="status-badge success">Request received</span>
			<h2>
				Thanks. Your interest has been shared with the App Launcher
				team.
			</h2>
			<button
				class="secondary-button"
				type="button"
				(click)="returnToApp()"
			>
				Return to App Launcher
			</button>
		</div>

		<ng-template #interestFormTpl>
			<form class="interest-form" (ngSubmit)="submit()">
				<div class="field">
					<label for="name">Name</label>
					<input id="name" name="name" [(ngModel)]="form.name" />
				</div>
				<div class="field">
					<label for="interestEmail">Email</label>
					<input
						id="interestEmail"
						name="email"
						type="email"
						[(ngModel)]="form.email"
					/>
				</div>
				<div class="field">
					<label for="capacity"
						>How many projects do you expect to deploy?</label
					>
					<input
						id="capacity"
						name="capacity"
						[(ngModel)]="form.capacity"
					/>
				</div>
				<div class="field">
					<label for="audience"
						>Are these for yourself or clients?</label
					>
					<select
						id="audience"
						name="audience"
						[(ngModel)]="form.audience"
					>
						<option>Client projects</option>
						<option>My own projects</option>
						<option>Both</option>
					</select>
				</div>
				<div class="field">
					<label for="notes">Optional notes</label>
					<textarea
						id="notes"
						name="notes"
						rows="4"
						[(ngModel)]="form.notes"
					></textarea>
				</div>
				<div class="form-actions">
					<button
						class="secondary-button"
						type="button"
						(click)="returnToApp()"
					>
						Cancel
					</button>
					<button class="primary-button" type="submit">
						Submit request
					</button>
				</div>
			</form>
		</ng-template>
	</section>
</main>
